export const getNewArticlePageUrl = (params?: Record<string, string>): string => {
  const queryParams = params ? `?${new URLSearchParams(params).toString()}` : '';
  const baseUrl = '/editor/new-article';
  return `${baseUrl}${queryParams}`;
};
